"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "bs_2979",
    description: "British Standard 2979:1958 transliteration schema",
    url: "https://dangry.ru/iuliia/bs-2979/",
    comments: [
        "This schema defines two alternative translations for `Ы`:",
        "  - `Ы` → `Ȳ` (used by the Oxford University Press)",
        "  - `Ы` → `UI` (used by the British Library).",
        "`iuliia` uses `Ы` → `Ȳ`.",
    ],
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "ё",
        ж: "zh",
        з: "z",
        и: "i",
        й: "ĭ",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "ts",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ъ: "ʺ",
        ы: "ȳ",
        ь: "ʹ",
        э: "é",
        ю: "yu",
        я: "ya",
    },
    prev_mapping: null,
    next_mapping: null,
    ending_mapping: { ий: "y", ый: "y" },
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Yuliya, sʺeshʹ eshchё étikh myagkikh frantsuzskikh bulok iz Ĭoshkar-Olȳ, da vȳpeĭ altaĭskogo chayu",
        ],
    ],
};
